// import { createSelector } from "reselect";
/** 
 * Selectors do cotacaoReducer, essas funções retornam algum campo específico
 * do nosso estado(state).
*/

// Envia todos os campos do state do cotacaoReducer.
export const selectCotacao = state => state.cotacao;